module.exports = __webpack_public_path__ + "static/img/04996480.94af3c6e.png";